import type { ReactNode } from "react";
import { ExpandableIndicator } from "@jetblue/kit/expandable-indicator";
import { HeaderMenuItem } from "./header-menu-item";

export type HeaderMenuProperties = {
  children?: ReactNode | undefined;
  isOpen: boolean;
  setOpen: () => void;
};
export const HeaderMenuButton = ({
  children,
  isOpen,
  setOpen,
}: HeaderMenuProperties) => (
  <HeaderMenuItem
    aria-expanded={isOpen}
    as="button"
    className="group/expandable-ui cursor-pointer"
    data-fs-element="main-nav-menu-button"
    onClick={setOpen}
  >
    <span
      className="
        flex w-full flex-row items-center justify-between text-subtitle-l
        font-semibold

        focus-visible:outline-1 focus-visible:outline-offset-[3px]
        focus-visible:outline-border-variant-lowest

        md:gap-2
      "
    >
      {children}
      <ExpandableIndicator className="inline size-3" />
    </span>
  </HeaderMenuItem>
);
